import { render, staticRenderFns } from "./TransitionExpand.vue?vue&type=template&id=06c5bc77&scoped=true"
import script from "./TransitionExpand.vue?vue&type=script&lang=js"
export * from "./TransitionExpand.vue?vue&type=script&lang=js"
import style0 from "./TransitionExpand.vue?vue&type=style&index=0&id=06c5bc77&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c5bc77",
  null
  
)

export default component.exports